import useSWR, { mutate } from "swr"
import API from "./api"

export default function useRESTResource({
  path,
  only = ["show", "create", "update", "destroy"],
}) {
  async function show() {
    return API.get(path)
  }

  async function create(createParams) {
    return API.post(path, createParams)
  }

  async function update(data) {
    const result = await API.put(path, data)
    mutate(path)

    return result
  }

  async function destroy() {
    await API.delete(path)
  }

  function refresh() {
    return mutate(path)
  }

  const key = only.includes("show") ? path : null

  const response = useSWR(key, show, {
    suspense: true,
  })

  const { data = {} } = response

  data.refresh = refresh
  if (only.includes("create")) data.create = create
  if (only.includes("update")) data.update = update
  if (only.includes("destroy")) data.destroy = destroy

  return { ...response, data }
}
